function moveSpinElement(observer) {
  const container = document.querySelector(".MagicToolboxSelectorsContainer");
  const spinElement = container?.querySelector('a[data-slide-id="spin"]');

  if (!container || !spinElement) return;

  // Skip if already in position 3 (index 2)
  if (container.children[3] === spinElement) return;

  const thirdChild = container.children[3];

  // Disconnect observer to prevent loop
  observer.disconnect();

  container.insertBefore(spinElement, thirdChild);
  
  // Reconnect observer after the change
  observer.observe(container, { childList: true, subtree: false });
}

document.addEventListener("DOMContentLoaded", function () {
    const container = document.querySelector(".MagicToolboxSelectorsContainer");
    if (!container) return;
    
    const observer = new MutationObserver(() => {
      console.log('MagicToolboxSelectorsContainer', this)
    });
    
    // Initial move
    moveSpinElement(observer);
    
    // Start observing
    observer.observe(container, { childList: true, subtree: false });
});

// document.querySelector('select[name="id"]').addEventListener("change", function() {
//     console.log("Variant changed manually");

//     // Refresh MagicToolbox
//     if (typeof MagicZoom !== 'undefined') {
//         MagicZoom.refresh();
//     }
// });

